import angular from 'angular';

(function() {
    'use strict';

    angular.module('app.prepasrel').factory('PrePasrelWorkflow', PrePasrelWorkflow);

    PrePasrelWorkflow.$inject = ['$filter'];

    /* @ngInject */
    function PrePasrelWorkflow($filter) {
        PrePasrelWorkflowData.prototype = {};

        function PrePasrelWorkflowData(data) {
            if (data) {
                this.name = data.name || null;
                this.buyerMask = data.buyerMask || null;
                this.putLocation = data.putLocation || null;
                this.getLocation = data.getLocation || null;
                this.lastModification = data.lastModification ? $filter('date')(data.lastModification, 'short') : null;
                this.audit = data.audit || null;
            } else {
                this.name = null;
                this.buyerMask = null;
                this.putLocation = null;
                this.getLocation = null;
                this.lastModification = null;
                this.audit = null;
            }
        }

        return PrePasrelWorkflowData;
    }
})();
